import { z } from "zod";

import { WEB_VIEW_ACTIONS } from "@/shared/lib";

const webViewActionSchema = z.enum(WEB_VIEW_ACTIONS);

export const webViewMessageSchema = z.object({
  type: webViewActionSchema,
  payload: z
    .record(z.string(), z.union([z.string(), z.number(), z.boolean()]))
    .optional(),
});
